export function isRoleClaim(
  claim: RoleClaim[] | string | unknown | null,
): claim is RoleClaim[] {
  return claim !== null && typeof claim === 'object';
}
